import "../ContentFrame.css";
import { MenuBar } from "../../components/MenuBar";
import Address from "../../components/Address";
const ProductAndSolution=(props)=>{

    return(
        <div className="h-screen w-screen min-w-[1200px]">
            <MenuBar
            selected_page={props.selected_page}
            />
            <div className = "w-full bg-white font-bold">
                <div className="w-full h-[300px] bg-black text-8xl font-bold text-white flex items-center justify-center bg-[length:100%_100%]" style={{backgroundImage:`url(${props.titleImage})`}}>
                        {props.titleText}
                </div>
                <div className="w-full flex justify-center items-center">
                    <div className="certificate_grid_container">{props.cardList}</div>
                </div>
                                
            </div>
            <Address/>
        </div>
    );
}
export default ProductAndSolution;